
export const server_url = "https://api.anano.com.br"
// export const server_url = "http://localhost:8080"
export const server_runner_url = "http://runner.anano.com.br"